export enum NotificationSounds {
  TEXT_NOTIFICATION = "textnotificationsound",
  CALL_NOTIFICATION = "callnotificationsound"
}